export enum OcdErrorCodesEnum {
  MAINTENANCE = '5003_1',
  NOT_AUTHORIZED = '4003_0',
  WAIT_FOR_APPROVAL = '4003_1',
}
